import i18n from 'Pods/Shared/I18n'

export const getTagTooltipText = (badge, locale = 'en') => {
  if (!badge) {
    return ''
  }

  switch (badge) {
    case 'BEST PRICE GUARANTEED':
      return i18n.t('itemPage.priceBadges.bestPriceGuaranteed', { ns: 'rails', lng: locale })

    case 'NEW':
      return i18n.t('itemPage.priceBadges.new', { ns: 'rails', lng: locale })

    case 'TOP SELLING':
      return i18n.t('itemPage.priceBadges.topSelling', { ns: 'rails', lng: locale })

    case 'QUALITY VERIFIED':
      return i18n.t('itemPage.priceBadges.cgtStandard', { ns: 'rails', lng: locale })

    case '3D PRINT VERIFIED':
      return i18n.t('itemPage.priceBadges.threeDPrintVerified', { ns: 'rails', lng: locale })

    case 'TOP RATED':
      return i18n.t('itemPage.priceBadges.topRated', { ns: 'rails', lng: locale })

    case 'AI GENERATED':
      return i18n.t('itemPage.priceBadges.aiGenerated', { ns: 'rails', lng: locale })

    case 'DESIGNER\'S PICK':
      return i18n.t('itemPage.priceBadges.designerPick', { ns: 'rails', lng: locale })

    default:
      return ''
  }
}
